import { UUID } from "src/types/shared.type";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ModifierItem } from "src/interfaces/modifier.interface";
import { NOT_FOUND_MODIFIER_ITEM_INDEX } from "src/constants/constants";
import type { MenuListActiveFilter } from "src/constants/menuListActiveFilter";

interface ModifierItemsState {
  modifierItems: ModifierItem[];
  toBeDeletedModifierItemId: UUID | null;
  /** Owner modifier items list filter; refetches without an argument use this. */
  listActiveFilter: MenuListActiveFilter;
}

const initialState: ModifierItemsState = {
  modifierItems: [],
  toBeDeletedModifierItemId: null,
  listActiveFilter: "ACTIVE",
};

export const modifierItemsSlice = createSlice({
  name: "modifierItems",
  initialState,
  reducers: {
    set_modifier_items: (state, action: PayloadAction<ModifierItem[]>) => {
      state.modifierItems = action.payload;
    },
    
    add_modifier_item: (state, action: PayloadAction<ModifierItem>) => {
      state.modifierItems.push(action.payload);
    },
    
    update_modifier_item: (state, action: PayloadAction<ModifierItem>) => {
      const modifierItemIndex = state.modifierItems.findIndex(
        modifierItem => modifierItem.correlationId === action.payload.correlationId
      );
      if (modifierItemIndex !== NOT_FOUND_MODIFIER_ITEM_INDEX) {
        state.modifierItems[modifierItemIndex] = action.payload;
      }
    },
    
    remove_modifier_item: (state, action: PayloadAction<UUID | null>) => {
      state.modifierItems = state.modifierItems.filter(
        modifierItem => modifierItem.correlationId !== action.payload
      );
    },
    
    // Modal States
    set_delete_modal_item_id: (state, action: PayloadAction<UUID | null>) => {
      state.toBeDeletedModifierItemId = action.payload;
    },

    set_modifier_items_list_active_filter: (state, action: PayloadAction<MenuListActiveFilter>) => {
      state.listActiveFilter = action.payload;
    },
  },
});

export const {
  set_modifier_items,
  add_modifier_item,
  update_modifier_item,
  remove_modifier_item,
  set_delete_modal_item_id,
  set_modifier_items_list_active_filter,
} = modifierItemsSlice.actions;

export default modifierItemsSlice.reducer;
